import { render } from "./BxToast.vue?vue&type=template&id=2768b536&scoped=true&ts=true"
import script from "./BxToast.vue?vue&type=script&lang=ts"
export * from "./BxToast.vue?vue&type=script&lang=ts"

import "./BxToast.vue?vue&type=style&index=0&id=2768b536&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2768b536"]])

export default __exports__